// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-company-contacts-indexstyleGrid-container-zlcgt{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-company-contacts-indexstyleGrid-grid-neggu{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-company-contacts-indexstyleGrid-col6-bcjdx{grid-column:span 6}.pages-company-contacts-indexstyleGrid-col3-levdy{grid-column:span 3}.pages-company-contacts-indexstyleGrid-col4-xnciu{grid-column:span 4}.pages-company-contacts-indexstyleGrid-col9-cbpdc{grid-column:span 9}.pages-company-contacts-indexstyleGrid-col12-cbwqy{grid-column:span 12}.pages-company-contacts-indexstyleGrid-alignItemsStart-blzeh{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-company-contacts-indexstyleGrid-container-zlcgt",
	"grid": "pages-company-contacts-indexstyleGrid-grid-neggu",
	"col6": "pages-company-contacts-indexstyleGrid-col6-bcjdx",
	"col3": "pages-company-contacts-indexstyleGrid-col3-levdy",
	"col4": "pages-company-contacts-indexstyleGrid-col4-xnciu",
	"col9": "pages-company-contacts-indexstyleGrid-col9-cbpdc",
	"col12": "pages-company-contacts-indexstyleGrid-col12-cbwqy",
	"alignItemsStart": "pages-company-contacts-indexstyleGrid-alignItemsStart-blzeh"
};
module.exports = ___CSS_LOADER_EXPORT___;
